// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6ad8cfb9","809":"1bb714a5"}[chunkId] + ".chunk.js";
};